import { type ENV, MfeConfig } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { getHeaderManifest } from '@carvana/header';

export const QUALI_CDN_PATH = 'carvana-quali-ui';
export const QUALI_MODULE = 'QualiModule';

const config = () =>
  MfeConfig({
    name: 'tradesUi',
    Render: MfeReact(),
    ENV: process.env.CARVANA_APP_MFE_ENV as ENV,
    globals: {
      axios: () => import('axios'),
      React: () => import('react'),
      ReactDOM: () => import('react-dom'),
      styled: () => import('styled-components'),
      'styled-components': () => import('styled-components'),
      PropTypes: () => import('prop-types'),
      'prop-types': () => import('prop-types'),
      ReactRouterDom: () => import('react-router-dom')
    },
    files: [
      [
        'FooterModule',
        [
          {
            component: 'default',
            browser: true,
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CARVANA_APP_CDN_URL
              }/footer/module/assets-manifest.json?v=${Date.now()}`
            }
          }
        ]
      ],
      [
        'HeaderModule',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: getHeaderManifest(process.env.CARVANA_APP_ENVIRONMENT)
            }
          }
        ]
      ],
      [
        QUALI_MODULE,
        [
          {
            component: 'default',
            local: {
              file: 'index.js',
              manifest: `http://localhost:2006/assets-manifest.json?v=${Date.now()}`
            },
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CARVANA_APP_STATIC_PUBLIC_URL
              }/${QUALI_CDN_PATH}/modules/assets-manifest.json?v=${Date.now()}`
            }
          }
        ]
      ]
    ]
  });

export default config;
